export const forestAnimals = [
  {
    questionText: "What animal is big and brown?",
    answerOptions: [
      { answerText: "Cat", isCorrect: false },
      { answerText: "Dog", isCorrect: false },
      { answerText: "Bear", isCorrect: true },
      { answerText: "Bird", isCorrect: false },
    ],
  },
  {
    questionText: "What animal swings from trees?",
    answerOptions: [
      { answerText: "zebra", isCorrect: false },
      { answerText: "Monkey", isCorrect: true },
      { answerText: "Dog", isCorrect: false },
      { answerText: "Horse", isCorrect: false },
    ],
  },
  {
    questionText: "What animal is known for building dams?",
    answerOptions: [
      { answerText: "Beaver", isCorrect: true },
      { answerText: "Shark", isCorrect: false },
      { answerText: "Aligator", isCorrect: false },
      { answerText: "Bird", isCorrect: false },
    ],
  },
  {
    questionText: "What animal has a bushy tail and likes nuts?",
    answerOptions: [
      { answerText: "Giraffe", isCorrect: false },
      { answerText: "Lion", isCorrect: false },
      { answerText: "Cow", isCorrect: false },
      { answerText: "Squirrel", isCorrect: true },
    ],
  },
  {
    questionText: "What animal has long ears and hops?",
    answerOptions: [
      { answerText: "Fish", isCorrect: false },
      { answerText: "Monkey", isCorrect: false },
      { answerText: "Rabbit", isCorrect: true },
      { answerText: "Tiger", isCorrect: false },
    ],
  },
  {
    questionText: "What animal has a long neck and is spotted?",
    answerOptions: [
      { answerText: "Giraffe", isCorrect: true },
      { answerText: "Rabbit", isCorrect: false },
      { answerText: "Snake", isCorrect: false },
      { answerText: "Bee", isCorrect: false },
    ],
  },
  {
    questionText: "What animal is black and white and climbs trees?",
    answerOptions: [
      { answerText: "Rhinoceros", isCorrect: false },
      { answerText: "Hippopotamus", isCorrect: false },
      { answerText: "Eagle", isCorrect: false },
      { answerText: "Panda", isCorrect: true },
    ],
  },
  {
    questionText: "What animal is known as the king of the forest?",
    answerOptions: [
      { answerText: "Whale", isCorrect: false },
      { answerText: "Lion", isCorrect: true },
      { answerText: "Bear", isCorrect: false },
      { answerText: "Crocodile", isCorrect: false },
    ],
  },
  {
    questionText: "What animal flies and has bright feathers?",
    answerOptions: [
      { answerText: "Pig", isCorrect: false },
      { answerText: "Snake", isCorrect: false },
      { answerText: "Shrimp", isCorrect: false },
      { answerText: "Parrot", isCorrect: true },
    ],
  },
  {
    questionText: "What animal has a shell and moves slowly?",
    answerOptions: [
      { answerText: "Turtle", isCorrect: true },
      { answerText: "Tiger", isCorrect: false },
      { answerText: "Wolf", isCorrect: false },
      { answerText: "Horse", isCorrect: false },
    ],
  },
  {
    questionText: "What animal lives in a hive and makes honey?",
    answerOptions: [
      { answerText: "Bee", isCorrect: true },
      { answerText: "Fly", isCorrect: false },
      { answerText: "Ant", isCorrect: false },
      { answerText: "Butterfly", isCorrect: false },
    ],
  },

  {
    questionText: "What animal is small, with a long tail and squeak?",
    answerOptions: [
      { answerText: "Mouse", isCorrect: true },
      { answerText: "Bull", isCorrect: false },
      { answerText: "Turtle", isCorrect: false },
      { answerText: "Rabbit", isCorrect: false },
    ],
  },
  {
    questionText: "What animal has sharp claws and roars?",
    answerOptions: [
      { answerText: "Fish", isCorrect: false },
      { answerText: "Horse", isCorrect: false },
      { answerText: "Tiger", isCorrect: true },
      { answerText: "Cow", isCorrect: false },
    ],
  },
  {
    questionText: "What animal is red and known for being smart?",
    answerOptions: [
      { answerText: "Chicken", isCorrect: false },
      { answerText: "Fox", isCorrect: true },
      { answerText: "Crab", isCorrect: false },
      { answerText: "Shark", isCorrect: false },
    ],
  },
  {
    questionText: "What animal is green and can change colors?",
    answerOptions: [
      { answerText: "Snake", isCorrect: false },
      { answerText: "Chameleon", isCorrect: true },
      { answerText: "Pik", isCorrect: false },
      { answerText: "Zebra", isCorrect: false },
    ],
  },
  {
    questionText: "What animal lives in colonies and works together?",
    answerOptions: [
      { answerText: "Elephant", isCorrect: false },
      { answerText: "Giraffe", isCorrect: false },
      { answerText: "Ladybug", isCorrect: false },
      { answerText: "Ant", isCorrect: true },
    ],
  },
  {
    questionText: "What animal is small and covered in prickly spines?",
    answerOptions: [
      { answerText: "Bird", isCorrect: false },
      { answerText: "Cat", isCorrect: false },
      { answerText: "Hedgehog", isCorrect: true },
      { answerText: "Dog", isCorrect: false },
    ],
  },
  {
    questionText: "What animal crawls and don't have arms and legs?",
    answerOptions: [
      { answerText: "Snake", isCorrect: true },
      { answerText: "Crocodile", isCorrect: false },
      { answerText: "Giraffe", isCorrect: false },
      { answerText: "Butterfly", isCorrect: false },
    ],
  },
  {
    questionText: "What animal can fly and has sharp claws?",
    answerOptions: [
      { answerText: "Panda", isCorrect: false },
      { answerText: "Dog", isCorrect: false },
      { answerText: "Bee", isCorrect: false },
      { answerText: "Eagle", isCorrect: true },
    ],
  },
  {
    questionText: "What animal has a striped coat and lives in the jungle?",
    answerOptions: [
      { answerText: "Hippopotamus", isCorrect: false },
      { answerText: "Giraffe", isCorrect: false },
      { answerText: "Lion", isCorrect: false },
      { answerText: "Tiger", isCorrect: true },
    ],
  },
  {
    questionText: "What animal has sharp teeth and swims in rivers?",
    answerOptions: [
      { answerText: "Elephant", isCorrect: false },
      { answerText: "Zebra", isCorrect: false },
      { answerText: "Bison", isCorrect: false },
      { answerText: "Crocodile", isCorrect: true },
    ],
  },
  {
    questionText:
      "What animal is a large cat with spots and lives in the forest?",
    answerOptions: [
      { answerText: "Fish", isCorrect: false },
      { answerText: "Whale", isCorrect: false },
      { answerText: "Lion", isCorrect: false },
      { answerText: "Leopard", isCorrect: true },
    ],
  },
  {
    questionText:
      "What animal has long arms and is known for its intelligence?",
    answerOptions: [
      { answerText: "Chimpanzee", isCorrect: true },
      { answerText: "Fish", isCorrect: false },
      { answerText: "Snake", isCorrect: false },
      { answerText: "Lion", isCorrect: false },
    ],
  },
  {
    questionText: "What animal is grey and has a trunk?",
    answerOptions: [
      { answerText: "Elephant", isCorrect: true },
      { answerText: "Horse", isCorrect: false },
      { answerText: "Ant", isCorrect: false },
      { answerText: "Crocodile", isCorrect: false },
    ],
  },
];
